// extracted by mini-css-extract-plugin
export default {"item":"CustomItem_item__Lv96M","button":"CustomItem_button__Erkcx","delete":"CustomItem_delete__PwjYv"};